export const GET_ERRORS = 'GET_ERRORS';
export const CLEAR_ERRORS = 'CLEAR_ERRORS';


// WEBPACK FOOTER //
// ./src/features/Errors/types.js